import React from 'react'
import Link from 'gatsby-link'

export default ({slug}) => (
    <nav className="navbar navbar-default navbar-static-top" role="navigation">
        <div className="container">
            <div className="navbar-header">
                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target=".navbar-collapse">
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                </button>
                <span className="navbar-brand visible-xs-block">Navigate</span>
            </div>
            <div className="navbar-collapse collapse">
                <ul className="nav navbar-nav">
                    <li className={(slug==="/")?'active':''}>
                        <a href="/">Home</a>
                    </li>
                    <li className={(slug.indexOf("/articles")===0)?'active':''}>
                        <a href="/articles/1">Articles</a>
                    </li>
                    <li className={(slug.indexOf("/music")===0)?'active':''}>
                        <a href="/music">Music</a>
                    </li>
                    <li className={(slug.indexOf("/photos")===0)?'active':''}>
                        <a href="/photos">Photos</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    )
    


// WEBPACK FOOTER //
// ./src/components/navigation.js